export default "__VITE_ASSET__Dr5Iea7e__"